export type CatalogRow = Record<string, unknown>;

const rows = (value: unknown): CatalogRow[] => {
    if (!Array.isArray(value) || value.some(row => !row || typeof row !== 'object' || Array.isArray(row))) {
        throw new Error('INVALID_PUBLIC_CATALOG_RESPONSE');
    }
    return value as CatalogRow[];
};

/** List loading never downloads the service matrix. Details are selected explicitly. */
export async function loadProgressiveRepairCatalog(
    request: (path: string) => Promise<unknown>,
    publish: (brands: CatalogRow[], models: CatalogRow[], services: CatalogRow[]) => void,
    signal: AbortSignal,
): Promise<void> {
    const [brands, models] = await Promise.all([
        request('/api/public/brands').then(rows),
        request('/api/public/models/all?view=index').then(rows),
    ]);
    if (signal.aborted) return;
    publish(brands, models, []);

}
